import { createReducer } from '@reduxjs/toolkit'
import { createBuilder } from 'packages/redux-toolkit'

import { getAllCfrLogs } from './actions'

interface CfrLogsState {
  list: {
    loading: boolean
    items: string[]
  }
}

const initialState: CfrLogsState = {
  list: {
    loading: false,
    items: [],
  },
}

export const cfrLogsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllCfrLogs.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllCfrLogs.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllCfrLogs.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload.logFileNames
    })
})
